import format from '@/utils/formatNumber'

export default (value, options) => format.percent(value, options)
